import { NgModule } from '@angular/core';
import { IsValidLegalFormPipe } from './valid-legal-form.pipe';

@NgModule({
  declarations: [IsValidLegalFormPipe],
  exports: [IsValidLegalFormPipe],
})
export class IsValidLegalFormPipeModule {}
